const ACCOUNT_PAGES = new Set([
  'billing',
  'identities',
  'manage',
  'podcasts',
  'preferences',
  'referrals',
  'review_order',
]);

const isSubscriberAccountPage = (pathname: string): boolean => {
  const [, root, subscriberId, page] = pathname.split('/');

  if (root !== 'subscribe') return false;
  if (!subscriberId || !page) return false;

  return ACCOUNT_PAGES.has(page);
};

export default isSubscriberAccountPage;
